import { hashJson } from '@basehub/utils/hash'
import { BlockRelationship } from '.'
import { getIdempotentId } from '@basehub/utils/id/get-idempotent-id'

// Extract just the base part of a fractional index, removing the tiebreaker
export function extractBaseOrder(order: string): string {
  // Skip very short strings (edge case protection)
  if (order.length < 4) return order

  // Remove the last 4 characters which contain the tiebreaker
  return order.slice(0, -4)
}

export function hashBr(br: BlockRelationship): string {
  return hashJson({
    blockId: br.blockId,
    sourceBlockId: br.sourceBlockId,
    parentId: br.parentId,
    order: extractBaseOrder(br.order), // Use only the base part of the order
  } satisfies Partial<BlockRelationship>)
}

export function getBRId(blockId: string, rootBlockId: string) {
  return getIdempotentId({ idSeed: `br_${rootBlockId}_${blockId}` })
}
